module.exports = __webpack_public_path__ + "img/autoc-loading.faa40e29.svg";